<template>
  <div>
    <!-- Logo skeleton -->
    <div class="sidebar-logo-skeleton" style="margin-top: 10px" hidden="">
      <div class="logo-container">
        <div v-if="!isCollapsed" class="logo-prefix"></div>
        <div class="logo-suffix"></div>
      </div>
    </div>

    <div class="sidebar-logo" style="margin-top: 10px">
      <tooltip name="tooltip" :pointer="true" :event="'hover'"/>
      <router-link :to="homeUrl || '/'" class="text-lg" style="font-size: 24px">
          <span v-if="this.$store.state.app.isExpandedMenu" class="font-weight-600 text-slate-100"
                style="color:#36385C;">{{
              $t("logo.prefix")
            }} </span>
        <span v-if="this.$store.state.app.isExpandedMenu" class="font-weight-bold text-slate-500"
              style="color: #fff; font-weight: bold; background-color: #004A59; padding: 6px; border-radius: 5px">{{
            $t("logo.suffix")
          }}</span>
        <span v-if="!this.$store.state.app.isExpandedMenu" class="font-weight-bold text-slate-500"
              style="color: #fff; font-weight: bold; background-color: #004A59; padding: 8px; border-radius: 5px">
           <i v-bind:class="$t('logo.icon')" style="padding: 8px"></i>
          </span>
      </router-link>
    </div>

    <div class="sidebar-inner">
      <hr style="margin: 20px 15px 0px;">

      <!-- Menu items skeleton -->
      <section class="ps-container scroll-area ps">
        <div class="sidebar-menu" style="padding-top: 0px !important;">
          <ul style="margin-top: 25px;">
            <li v-for="n in menuItems" :key="n" class="skeleton-menu-item">
              <div class="skeleton-link">
                <div class="skeleton-icon"></div>
                <div v-if="!isCollapsed" class="skeleton-text"></div>
              </div>
            </li>
          </ul>
        </div>

        <!-- Scroll rails for visual consistency -->
        <div class="ps__rail-x" style="left: 0px; bottom: 0px;">
          <div class="ps__thumb-x" tabindex="0" style="left: 0px; width: 0px;"></div>
        </div>
        <div class="ps__rail-y" style="top: 0px; right: 0px;">
          <div class="ps__thumb-y" tabindex="0" style="top: 0px; height: 0px;"></div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "SidebarSkeleton",
  data() {
    return {
      homeUrl: this.$store.state.app.homeUrl || '/'
    };
  },
  props: {
    isCollapsed: {
      type: Boolean,
      default: false
    },
    menuItems: {
      type: Number,
      default: 8
    }
  }
}
</script>

<style scoped>
.sidebar-logo-skeleton {
  padding: 0 15px;
}

.logo-container {
  display: flex;
  align-items: center;
}

.logo-prefix {
  height: 24px;
  width: 80px;
  margin-right: 8px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.1) 25%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.1) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}

.logo-suffix {
  height: 30px;
  width: 60px;
  background: linear-gradient(90deg, #003640 25%, #004A59 50%, #003640 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 5px;
}

.skeleton-menu-item {
  margin: 8px 0;
  padding: 4px 8px;
}

.skeleton-link {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 4px;
}

.skeleton-icon {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.1) 25%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.1) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.skeleton-text {
  height: 16px;
  width: 120px;
  margin-left: 10px;
  border-radius: 4px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.1) 25%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.1) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/SidebarSkeleton.vue